import * as CryptoJS from 'crypto-js';


export var config = {
  "baseUrl": "https://mcapi-server.herokuapp.com/",
  "username": "",
  "password": "",
  "baseEndpoint": "https://mcapi-server.herokuapp.com/",
  "viewername": "mosh",
  "viewerpass": "password",
  "key": "UHQZ8eHaZL"
}




// WEBPACK FOOTER //
// /tmp/build_713add00/src/config/config.ts